﻿'use strict';
/**
 * appLogSvc: global application logging service
 * 
 * appLogSvc is a global application logging service that preserves the default logging behaviour (logging to the console)
 * but also posts the log message server side.
**/

var rp = require('request-promise');


// @ngInject 
module.exports = function ($log, $window, $location) {

        var reqOpts = {
            encoding: 'utf8',
            uri: $window.location.origin + '/api/logger',
            method: 'POST',
            json: true,
            body: {
                url: $window.location.href,
                npeId: $location.search()['npeid'],
                message: '',
                type: "info"
            }
        }

    return {
        log: function(message) {
            $log.log.apply($log, arguments);

            reqOpts.body.url = $window.location.href;
            reqOpts.body.message = message;

            rp(reqOpts).catch(function(loggingError) {
                $log.warn("Server-side logging failed.");
                $log.log(loggingError);
            });
        }
    };
}